import utils from '../utils/utils'
import { animate, stagger } from 'animejs';
import globalVar from '../utils/globalVar'

class Module00Filters {
  constructor() {
    let cache = {};
    let selected = {};

    let initFunc = () => {
      initCache();
      if (!cache.module) return;
      registerEvents();
    }

    let initCache = () => {
      cache.module  = document.querySelector('.module-00-filters');
      if (!cache.module) return;
      cache.ctaOpen     = cache.module.querySelector('.title-container .filters-cta');
      cache.panelContainer   = cache.module.querySelector('.filters_container');
      cache.panel   = cache.module.querySelector('.filters');
      cache.btns    = cache.module.querySelectorAll('.filter-btn');
      cache.apply   = cache.module.querySelectorAll('.filter-apply, .filters_container .filters-cta, .filters_container .overlay');
      cache.cards   = document.querySelectorAll('.module-00-filters .cards-container .item, .module-10-cards .item');
    };

    let registerEvents = () => {
      cache.ctaOpen.addEventListener('click', togglePanel);
      cache.btns.forEach(btn => {
        btn.addEventListener('click', toggleFilter);
        btn.addEventListener('mouseenter', dimSiblings);
        btn.addEventListener('mouseleave', undimSiblings);
      });
      cache.apply.forEach(btn => {
        btn.addEventListener('click', applyFilters);
      });
    };

    let togglePanel = () => {
      cache.panelContainer.classList.contains('is-open') ? closePanel() : openPanel();
    };

    let openPanel = () => {
      cache.panelContainer.classList.add('is-open');
      cache.panelContainer.style.display = 'block';
      animate(cache.panelContainer, {
        opacity: [0, 1],
        duration: 300,
        ease: 'outQuad',
      });
      animate(cache.panel, {
        x: ['100%', '0'],
        duration: 350,
        delay: 300,
        ease: 'outQuad',
      });
    };

    let closePanel = () => {
      animate(cache.panel, {
        x: ['0', '100%'],
        duration: 400,
        ease: 'inQuad',
      });
      animate(cache.panelContainer, {
        opacity: [1, 0],
        delay: 400,
        duration: 300,
        ease: 'inQuad',
        onComplete: () => {
          cache.panelContainer.classList.remove('is-open');
          cache.panelContainer.style.display = 'none';
        },
      });
    };

    let getSiblings = function() {
      return this.closest('.filter-group').querySelectorAll('.filter-btn:not([data-term="' + this.dataset.term + '"])');
    };

    let dimSiblings = function() {
      getSiblings.call(this).forEach(btn => btn.classList.add('is-dimmed'));
    };

    let undimSiblings = function() {
      // Keep dimmed if another btn in the group is active
      const activeBtn = this.closest('.filter-group').querySelector('.filter-btn.is-active');
      if (!activeBtn) {
        getSiblings.call(this).forEach(btn => btn.classList.remove('is-dimmed'));
      }
    };

    let toggleFilter = function() {
      const term     = this.dataset.term;
      const group    = this.closest('.filter-group').dataset.group;
      const isActive = this.classList.contains('is-active');
      const siblings = getSiblings.call(this);

      siblings.forEach(btn => btn.classList.remove('is-active'));

      if (isActive) {
        this.classList.remove('is-active');
        siblings.forEach(btn => btn.classList.remove('is-dimmed'));
        selected[group] = [];
      } else {
        this.classList.add('is-active');
        siblings.forEach(btn => btn.classList.add('is-dimmed'));
        selected[group] = [term];
      }
    };

    let applyFilters = () => {
      closePanel();

      const hasFilters = Object.values(selected).some(terms => terms.length > 0);

      // Sort cards into show/hide
      const toShow = [];
      const toHide = [];
      cache.cards.forEach(card => {
        if (!hasFilters) { toShow.push(card); return; }
        const cardTerms = (card.dataset.terms || '').split(',').map(t => t.trim());
        const match = Object.values(selected).every(terms => {
          if (terms.length === 0) return true;
          return terms.some(term => cardTerms.includes(term));
        });
        (match ? toShow : toHide).push(card);
      });

      // Get unique parent containers
      const containers = [...new Set([...cache.cards].map(card => card.parentElement))];

      // Lock container heights before DOM changes
      containers.forEach(c => { c.style.height = c.offsetHeight + 'px'; c.style.overflow = 'hidden'; });

      // Fade out all cards, then swap visibility and animate height + fade in
      animate([...cache.cards], {
        opacity: [1, 0],
        duration: 800,
        delay: stagger(60, { from: 'last' }),
        ease: 'outQuad',
        onComplete: () => {
          toHide.forEach(card => { card.style.display = 'none'; });
          toShow.forEach(card => { card.style.display = ''; card.style.opacity = '0'; });

          containers.forEach(c => {
            const newHeight = c.scrollHeight;
            animate(c, {
              height: [parseFloat(c.style.height), newHeight],
              duration: 400,
              ease: 'inOutQuad',
              onComplete: () => { c.style.height = ''; c.style.overflow = ''; },
            });
          });

          animate(toShow, {
            opacity: [0, 1],
            duration: 400,
            delay: stagger(60, { start: 150 }),
            ease: 'outQuad',
          });
        },
      });
    };

    initFunc();
  };
}
export { Module00Filters }
